import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "data-name": "Group 5499",
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  "data-name": "Rectangle 3330",
  width: "22",
  height: "22",
  rx: "11",
  style: {"fill":"#e91e63"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 8294",
  d: "M.37 22.853c.373 0 .35 0 .407.388a2.3 2.3 0 0 0 1.723 1.87 2.331 2.331 0 0 0 2.836-1.745 2.2 2.2 0 0 0 .021-.6c-.015-.236.083-.3.306-.3 1.1.009 2.2 0 3.307.007a.336.336 0 0 0 .384-.249 1.524 1.524 0 0 1 1.521-.916 1.468 1.468 0 0 1 1.362.95 1.517 1.517 0 0 1-.325 1.677 1.554 1.554 0 0 1-2.577-.5.272.272 0 0 0-.305-.2q-1.337.008-2.673 0c-.183 0-.255.064-.289.244A3.039 3.039 0 0 1 3.131 25.9a3.077 3.077 0 0 1-2.257-.894 3.121 3.121 0 0 1-.869-1.886c-.04-.33.179-.266.365-.267m10.393.828a.842.842 0 0 0 .87-.8.85.85 0 0 0-1.7-.013.837.837 0 0 0 .829.815",
  transform: "translate(4.076 -8.655)",
  style: {"stroke":"#fbfffb","stroke-width":".5px","fill":"#fff"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 8295",
  d: "M9.557.013a2.507 2.507 0 0 1 1.381.31c.194.092.248.2.1.377a.61.61 0 0 0-.086.14c-.088.193-.192.243-.409.136A2.3 2.3 0 0 0 7.182 3.11 2.061 2.061 0 0 0 8.26 4.968c.182.1.27.177.129.41-.553.918-1.076 1.854-1.616 2.78a.2.2 0 0 0 .027.283 1.458 1.458 0 0 1 .261 1.593 1.5 1.5 0 0 1-1.434.986A1.547 1.547 0 0 1 4.04 9.511a1.488 1.488 0 0 1 1.489-1.6.757.757 0 0 0 .833-.51c.324-.625.7-1.224 1.065-1.829a.223.223 0 0 0-.052-.329 3.072 3.072 0 0 1-.314-4.059A2.815 2.815 0 0 1 9.557.013M5.6 10.272a.823.823 0 0 0 .853-.822.866.866 0 0 0-.826-.833.828.828 0 1 0-.027 1.655",
  transform: "translate(1.535 4.754)",
  style: {"stroke":"#fbfffb","stroke-width":".5px","fill":"#fff"}
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 8296",
  d: "M23.009 11.987a3.069 3.069 0 0 1-1.416 2.532c-.03.02-.079.053-.1.042-.182-.111-.217-.327-.331-.488-.083-.118.025-.172.111-.234a2.218 2.218 0 0 0 .938-1.436 2.3 2.3 0 0 0-1.869-2.751 2.181 2.181 0 0 0-1.651.336c-.2.134-.28.059-.373-.1-.5-.876-1.006-1.749-1.5-2.627a.321.321 0 0 0-.407-.2 1.548 1.548 0 0 1-1.671-.8 1.572 1.572 0 0 1 .28-1.855 1.488 1.488 0 0 1 1.545-.381A1.529 1.529 0 0 1 17.654 5.2a1.374 1.374 0 0 1-.214 1.15.417.417 0 0 0-.012.5c.421.71.832 1.425 1.238 2.144.075.131.144.089.245.053a3.068 3.068 0 0 1 4.01 2.174 2.778 2.778 0 0 1 .088.765m-6.9-7.286a.807.807 0 0 0-.823.84.843.843 0 0 0 .83.817.8.8 0 0 0 .827-.834.793.793 0 0 0-.834-.823",
  transform: "translate(-5.086 2.271)",
  style: {"stroke":"#fbfffb","stroke-width":".5px","fill":"#fff"}
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render };